/*
 * lunna-cart-motion.js — driver for the add-to-cart moment.
 *
 * It changes no purchase behaviour and patches no theme file. Origin already
 * publishes `cartUpdate` on a successful add, so this listens for it and does
 * two things the theme leaves undone: it confirms on the button the visitor
 * actually pressed, and it pops the header counter. Every keyframe lives in
 * lunna-cart-motion.css; this file only decides when.
 *
 * The button is remembered at submit time rather than looked up when the cart
 * responds. By then a quick-add modal may have closed and its card may have
 * been re-rendered — the element that was pressed no longer exists, and a
 * lookup would either find nothing or, worse, decorate the wrong button on the
 * page. Capturing on the way in is the only moment the right element is
 * certain.
 *
 * With this script absent, adding to cart works exactly as it does today. The
 * confirmation is an addition, never a dependency.
 */
(function () {
  'use strict';

  if (window.LunnaCartMotion) return;
  window.LunnaCartMotion = true;

  var CHECK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" ' +
    'stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  /* How long the confirmation stays. Long enough to be read after the eye has
     moved to the drawer, short enough that the button is its normal self again
     before anyone thinks to press it a second time. */
  var HOLD = 2400;

  var lastButton = null;

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.matches !== 'function') return;
      if (!form.matches('form[action*="/cart/add"]')) return;
      lastButton = form.querySelector('[type="submit"]');
    },
    true
  );

  function confirmOn(button) {
    if (!button || !button.isConnected) return;
    if (button.dataset.lunnaConfirming === '1') return;
    button.dataset.lunnaConfirming = '1';

    var mark = document.createElement('span');
    mark.className = 'lunna-atc-check';
    mark.setAttribute('aria-hidden', 'true');
    mark.innerHTML = CHECK;

    button.insertBefore(mark, button.firstChild);
    button.classList.add('lunna-atc--done');

    window.setTimeout(function () {
      button.classList.remove('lunna-atc--done');
      mark.remove();
      button.dataset.lunnaConfirming = '0';
    }, HOLD);
  }

  /* The header section is re-rendered as part of the add, so the bubble held
     a moment ago may already have been replaced by the time this runs. Look it
     up fresh, and only after that swap has had a frame to land. */
  function popCounter() {
    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (!bubble) return;

        // Restart rather than re-add: a second add to the same cart would
        // otherwise set a class that is already there and play nothing.
        bubble.classList.remove('lunna-cart-pop');
        void bubble.offsetWidth;
        bubble.classList.add('lunna-cart-pop');

        // Take the class off once it has played. The drawer usually replaces
        // this element on the next add anyway, but a class that outlives its
        // animation is a lie to whoever reads the DOM later.
        bubble.addEventListener(
          'animationend',
          function () {
            bubble.classList.remove('lunna-cart-pop');
          },
          { once: true }
        );
      }, 80);
    });
  }

  function start() {
    if (typeof subscribe !== 'function') return;
    if (typeof PUB_SUB_EVENTS !== 'object' || !PUB_SUB_EVENTS) return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // Quantity edits inside the cart publish the same event. Only an add
      // from a product form is a moment worth marking.
      if (!event || event.source !== 'product-form') return;

      popCounter();

      /* Origin clears the button's `loading` class in a `finally`, which runs
         after this callback. Confirming immediately would put the check beside
         a spinner that is about to disappear. */
      var button = lastButton;
      window.setTimeout(function () {
        confirmOn(button);
      }, 140);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
